import { Helmet } from "react-helmet-async"
import { Container } from "@sembark-travel/ui-base"
import { useParams } from "../../../../router-utils"
import { EditRateSheet } from "../../../../RateSheets"

export default function EditRateSheetPage() {
	const { rateSheetId } = useParams("/rate-sheets/:rateSheetId/edit")

	return (
		<>
			<Helmet>
				<title>Edit Rate Sheet</title>
			</Helmet>
			<Container paddingX="0" bgColor="default">
				<EditRateSheet rateSheetId={rateSheetId} />
			</Container>
		</>
	)
}
